var cov_76jl0hnul = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tabs/styles/index.js",
      hash = "6f3efe8e82be093c743c2ff9b0c5a233ac498f5f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tabs/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tabsLess = {};
import genaration from '../../utils/classname';
export var tabsClass = (cov_76jl0hnul.s[0]++, genaration(tabsLess, 'tabs'));